import {url, post} from "../../app/services/Backend/HttpRequest"

export default {
  namespaced: true,
  state() {
    return {
      affiliate: {
        email: null,
        token: null,
      },
      failed: false
    }
  },
  mutations: {
    fill(state, payload) {
      state.affiliate = payload

      state.failed = false
    },

    fail(state, payload) {
      state.failed = true
    },

    erase(state, payload) {
      state.affiliate = {
        email: null
      }
    },
  },
  actions: {
    password({commit}, payload) {

      const input = {
        url: url('login/password'),
        payload
      }

      return post(input)
        .then(response => commit('fill', response.data))
        .catch(error => {
          commit('fail')
        })
    },

    token({commit}, payload) {

      const input = {
        url: url('login/token'),
        payload
      }

      return post(input)
        .then(response => commit('fill', response.data))
    },
  },
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/auth.js